'use client'

import { useScrollTracking } from '~/hooks/use-scroll-tracking.hook'

export const SpaceDetailsScrollTracking = () => {
	useScrollTracking({ eventNameSuffix: 'space-details' })

	return null
}
